// extracted by mini-css-extract-plugin
export var authorFullName = "blog-author-panel-module--authorFullName--fbac1";
export var authorShortBio = "blog-author-panel-module--authorShortBio--fd9f4";
export var contentBox = "blog-author-panel-module--contentBox--9a64c";
export var contentContainer = "blog-author-panel-module--contentContainer--81808";
export var cta = "blog-author-panel-module--cta--a1d83";
export var ctaContainer = "blog-author-panel-module--ctaContainer--9d31b";
export var picture = "blog-author-panel-module--picture--fb2c1";
export var wrapper = "blog-author-panel-module--wrapper--0093a";